import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        additionalProperties: {},
        filenames: {},
    },

    getters: {
        additionalProperties: state => state.additionalProperties,
        additionalPropertiesById: state => id => {
            return state.additionalProperties[id] || {};
        },
        filenames: state => state.filenames,
        filenameById: state => id => {
            return state.filenames[id] || null;
        },
    },

    mutations: {
        SET_ADDITIONAL_PROPERTY(state, { instanceId, data }) {
            if (state.additionalProperties[instanceId]) {
                Object.assign(state.additionalProperties[instanceId], data);
            } else {
                Vue.set(state.additionalProperties, instanceId, data);
            }
        },
        UPDATE_ADDITIONAL_PROPERTY(state, { instanceId, propId, value, name, prop_value }) {
            if (!state.additionalProperties[instanceId]) {
                Vue.set(state.additionalProperties, instanceId, {});
            }

            Vue.set(state.additionalProperties[instanceId], propId, { value, name, prop_value });
        },
        SET_FILENAME(state, { instanceId, fileName }) {
            Vue.set(state.filenames, instanceId, fileName);
        },
        CLEAR_ADDITIONAL_PROPERTIES_BY_ID(state, { instanceId }) {
            if (state.additionalProperties[instanceId]) {
                Vue.set(state.additionalProperties, instanceId, {});
            }
        },
    },

    actions: {
        async addAdditionalProperty({ commit }, { instanceId, data }) {
            commit('SET_ADDITIONAL_PROPERTY', { instanceId, data });
        },
        async updateAdditionalProperty({ commit }, { instanceId, propId, value, name, prop_value }) {
            commit('UPDATE_ADDITIONAL_PROPERTY', { instanceId, propId, value, name, prop_value });
        },
        async updateFilename({ commit }, { instanceId, fileName }) {
            commit('SET_FILENAME', { instanceId, fileName });
        },
        async clearAdditionalPropertiesById({ commit }, { instanceId }) {
            commit('CLEAR_ADDITIONAL_PROPERTIES_BY_ID', { instanceId });
        },
    },
};